







































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import DivertUser from "./divertuser.vue";

class PageUserRequest extends PageRequest {
  keyword: string;
  tenantId: number;
}

@Component({
  components: { DivertUser },
})
export default class TenantUser extends AbpBase {
  //filters
  pagerequest: PageUserRequest = new PageUserRequest();
  treedata: [] = [];
  userId: any[] = []; //被选择Id
  userName: any[] = []; //被选择的用户名
  divertModalShow: boolean = false; //转移
  splitnum: number = 0.15;
  async itemtree() {
    await this.$store
      .dispatch("tenant/getAllTenants")
      .then((val) => {
        this.treedata = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.tenantId = Number.parseInt(item[0].id);
    }
    this.$store.commit("tenantuser/setCurrentPage", 1);
    this.getpage();
  }
  get list() {
    return this.$store.state.tenantuser.list;
  }
  get loading() {
    return this.$store.state.tenantuser.loading;
  }
  pageChange(page: number) {
    this.$store.commit("tenantuser/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("tenantuser/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: "tenantuser/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.tenantuser.pageSize;
  }
  get totalCount() {
    return this.$store.state.tenantuser.totalCount;
  }
  get currentPage() {
    return this.$store.state.tenantuser.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      type: "selection",
      key: "selection",
      fixed: "left",
      width: 60,
      align: "center",
    },
    {
      title: this.L("UserName"),
      key: "userName",
      width: 150,
    },
    {
      title: this.L("TenancyName"),
      key: "name",
      width: 240,
    },
    {
      title: this.L("Mobile"),
      key: "mobile",
      width: 150,
    },
    {
      title: this.L("Email"),
      key: "email",
      width: 150,
    },
  ];
  async created() {
    await this.itemtree();
    this.getpage();
  }
  //重置密码
  divertUser() {
    let val = (this.$refs.selection as any).getSelection();
    if (val.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose"),
      });
      return;
    }
    this.userId = [];
    this.userName = [];
    val.forEach((ele) => {
      this.userId.push(ele.id);
      this.userName.push(ele.userName);
    });
    this.divertModalShow = true;
  }
}
